/**
 * Коды регионов репликации Bunny Stream. Ровно те, что принимает core API
 * в `ReplicationRegions` при создании библиотеки.
 *
 * Цены здесь намеренно нет: тарифы Bunny меняются, а показывать
 * устаревшую цифру в кабинете хуже, чем не показывать никакой. Партнёр
 * видит только предупреждение, что каждая реплика умножает стоимость
 * хранения (bunnySettings.account.regionsHelper).
 */
export const BUNNY_REPLICATION_REGIONS = [
  "UK",
  "SE",
  "NY",
  "LA",
  "SG",
  "SYD",
  "BR",
  "JH",
] as const;

export type BunnyReplicationRegion = (typeof BUNNY_REPLICATION_REGIONS)[number];
